import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { process } from '../utils/format';
import Card from 'react-bootstrap/Card';


function Post({ post, includeHeader = true }) {
    const {
        User,
        Attachments,
        postUsername,
        postTime,
        postText,
        forumName,
        postSubject,
        topicId,
        forumId,
        id
    } = post
    const date = new Date(postTime * 1000);
    const formattedDate = date.toDateString();
    const { email } = User || {};
    const emailLink = getEmailLink(postUsername, email);

    function getEmailLink(username, email) {
        return email ? <a key={Date.now()} href={`mailto:${email}`} rel='noreferrer' target='_blank'>{username}</a> : <span>{username}</span>;
    }

    function renderAttachments(Attachments) {
        function renderLink({ fileName, filePrefix, id, extension, wrapped }) {
            return <a target='_blank' rel='noreferrer' href={`${process.env.REACT_APP_SERVER_URL}assets/${filePrefix}`}>{wrapped || fileName}</a>
        }

        const noAttachments = !Attachments?.length
        return (
            noAttachments ?
                <></>
                :
                <>
                    <hr />
                    <Row>
                        <Col>
                            <ul>
                                {Attachments.map(attachment => {
                                    const { filePrefix, id, extension, comment } = attachment;
                                    switch (extension) {
                                        case 'jpeg':
                                        case 'jpg':
                                        case 'png':
                                        case 'gif':
                                            return (
                                                <li className='image-link' key={id}>
                                                    {renderLink({ 
                                                        ...attachment, 
                                                        wrapped: 
                                                            <img 
                                                                className='linked-image'
                                                                alt={comment}
                                                                src={`${process.env.REACT_APP_SERVER_URL}assets/${filePrefix}`}
                                                            />
                                                        }
                                                    )}
                                                    {renderLink(attachment)}
                                                </li>
                                            )
                                        default:
                                            return (
                                                <li key={id}>
                                                    {renderLink(attachment)}
                                                </li>
                                            );
                                    }
                                })}
                            </ul>
                        </Col>
                    </Row>
                </>
        );
    }

    return (
        <Card key={id} className='post-card' >
            {
                includeHeader ? 
                    <Card.Header>
                        <span className='forum-name'>
                            {forumName}
                        </span>
                        <a
                            className='forum-link'
                            href={`/list-topics/${forumId}`}
                            title='Show all posts within this forum block'
                        >
                            <span className='go-to-forum-link'>Go to Forum</span>
                            <i className="fa-sharp fa-solid fa-circle-chevron-up"></i>
                        </a>
                    </Card.Header>
                :
                <>
                </>
            }
            <Card.Body>
                <Card.Title>
                    <span className='subject-text' title={postSubject}>
                        {postSubject}
                    </span>
                    {
                        includeHeader ? 
                            <a
                                className='subject-link'
                                href={`/show-topic/${topicId}`}
                                title='Show all posts with this topic'
                            >
                                <span>Go to Topic </span>
                                <i className="fa-lg fa-sharp fa-solid fa-caret-right"/>
                            </a>
                        : 
                        <></>
                    }
                </Card.Title>
                <hr />
                <div className='post-area' dangerouslySetInnerHTML={
                    { __html: process(postText) }
                }>
                </div>
                <Row>
                    <Col>
                        <div className='author author-area'>
                            <div className='author-name'>
                                {emailLink}
                            </div>
                            <div className='created-date'>
                                {formattedDate}
                            </div>
                        </div>
                    </Col>
                </Row>
                {renderAttachments(Attachments)}
            </Card.Body>
        </Card>
    )
}

export default Post;